import { Component, Input, ViewChild, AfterViewInit, OnInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { Subscription, SubscriptionItem } from '@data/models/accounting-sage.model';
import { translateDuration, buildPageSizeOptions } from '@shared/utils/utilities';

const DEFAULT_LIST_SIZE = 10;

@Component({

    selector: 'syn-subscription',
    templateUrl: 'subscription.component.html',
    styleUrls: ['subscription.component.scss']
})
export class SubscriptionComponent implements AfterViewInit, OnInit {

    @Input() pageSize: Number;
    @Input() pageSizeOptions: Number[] = [];

    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;

    localeFrequency: string;
    localeDuration: string;
    public query: string;

    displayedColumns = ['code', 'name', 'quantity'];
    dataSource: MatTableDataSource<SubscriptionItem>;
    showPaginator = false;

    private _subscription: Subscription;

    get subscription(): Subscription {
        return this._subscription;
    }

    @Input() set subscription(value: Subscription) {
        this._subscription = value;

        if (value) {
            // I18N: i18n hack: waiting for proper localization implementation
            this._subscription.frequency = translateDuration(this._subscription.frequency, 'fr');
            this._subscription.duration = translateDuration(this._subscription.duration, 'fr');
        }
    }

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    ngOnInit() {
        if (this._subscription) {
            this.pageSizeOptions = buildPageSizeOptions(this._subscription.items);
            this.pageSize = this.pageSizeOptions.length === 0 ? 0 : DEFAULT_LIST_SIZE;
            this.dataSource = new MatTableDataSource<SubscriptionItem>(this._subscription.items);
            this.showPaginator = (this._subscription.items.length > DEFAULT_LIST_SIZE);
        } else {
            this.dataSource = new MatTableDataSource<SubscriptionItem>([]);
        }
    }

    applyFilter(searchFilter: string) {
        this.query = searchFilter.trim(); // Remove whitespace
        this.query = this.query.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = this.query;
    }

    clearQuery() {
        this.query = '';
        this.applyFilter('');
    }


}
